// extracted by mini-css-extract-plugin
export default {"input_area":"AiPresentation_input_area__Sy1sR","label":"AiPresentation_label__61zmO","download":"AiPresentation_download__uXV-8"};